import React, { Component, useEffect, useState } from 'react';

interface RouteErrorBoundaryProps {
  children: React.ReactNode;
}

interface RouteErrorBoundaryState {
  hasError: boolean;
}

export class RouteErrorBoundary extends Component<RouteErrorBoundaryProps, RouteErrorBoundaryState> {
  state: RouteErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): RouteErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Failed to load a FinBuffer page.', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="loading" role="alert">
          <p>We couldn&apos;t load this page. Your saved data stays on this device.</p>
          <button type="button" onClick={() => window.location.reload()}>
            Reload page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export function RouteLoadingFallback() {
  const [isTakingTooLong, setIsTakingTooLong] = useState(false);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => setIsTakingTooLong(true), 15_000);
    return () => window.clearTimeout(timeoutId);
  }, []);

  if (isTakingTooLong) {
    return (
      <div className="loading" role="alert">
        <p>This page is taking longer than expected. Your saved data stays on this device.</p>
        <button type="button" onClick={() => window.location.reload()}>
          Reload page
        </button>
      </div>
    );
  }

  return (
    <div className="loading" role="status" aria-live="polite">
      Loading...
    </div>
  );
}
